export const apiUrl = process.env.REACT_APP_API_BASIC_URL
export const fileURL = process.env.REACT_APP_IMAGE_URL

/** Media host for relative upload paths (falls back to API origin minus /api). */
export const getMediaBaseUrl = (): string => {
  const fromEnv = (fileURL || '').trim()
  if (fromEnv) return fromEnv.replace(/\/$/, '')
  const api = (apiUrl || '').trim()
  if (!api) return ''
  return api.replace(/\/api\/?$/i, '').replace(/\/$/, '')
}

export const resolveMediaUrl = (path?: string | null): string => {
  const raw = String(path ?? '').trim()
  if (!raw || raw === 'null' || raw === 'undefined') return ''

  // Already an absolute URL (e.g. DigitalOcean Spaces public URL) — use as-is.
  if (/^https?:\/\//i.test(raw)) return raw

  // Protocol-relative URL (//host/path) — prefer https.
  if (/^\/\//.test(raw)) return `https:${raw}`

  // Scheme-less but clearly a remote host (e.g. an object-storage endpoint
  // stored without the https:// prefix): "host.tld/key" / "www.host.tld/key".
  if (/^(www\.|[a-z0-9-]+\.[a-z0-9-]+.*\/)/i.test(raw) && /\.[a-z]{2,}\//i.test(raw)) {
    return `https://${raw.replace(/^\/+/, '')}`
  }

  const base = getMediaBaseUrl()
  if (!base) return raw.replace(/^\//, '')
  return `${base}/${raw.replace(/^\//, '')}`
}

/** Profile / avatar src with fallback when path or resolved URL is empty. */
export const profilePictureSrc = (
  path?: string | null,
  fallbackPath = '/media/user2.png'
): string => {
  if (!path || !String(path).trim()) return fallbackPath
  const url = resolveMediaUrl(path)
  return url || fallbackPath
}
